import React from 'react';
import { useState } from 'react';
import { useStorage } from '~Components/Storage';
import NumberInput from '~ComponentsImproved/Numpad';
import { useI18n, useLogger } from '~Hooks';
import { MethodProps } from '../types';
import { v4 as uuid } from 'uuid';

const AdyenManual: React.FunctionComponent<MethodProps> = ({ payment, onComplete, onFail }) => {
  const [{ enableTipping }] = useStorage();
  const [showTipModal, setShowTipModal] = useState(!payment.disableTip && enableTipping);
  const { i18n } = useI18n();
  const logger = useLogger('payment:adyen-manual');

  if (showTipModal) {
    return (
      <NumberInput
        key="tip"
        initialValue={'0'}
        decimal
        title={i18n('TM.Tip')}
        onSubmit={(tipAmount) => {
          setShowTipModal(false);

          // Ensure input is valid
          const num = parseFloat(tipAmount);
          if (isNaN(num)) {
            logger.warn(`AdyenManual payment failed, invalid input ${num}`, { id: payment.id });
            onFail();
            return;
          }

          // Complete payment with added tip after a slight delay
          setTimeout(() => onComplete(undefined, { tip: num * 100, transactionId: uuid() }), 2000);
        }}
        onClose={() => {
          setShowTipModal(false);
          onFail(i18n('Adyen.CanceledPayment'));
        }}
      />
    );
  } else {
    // Complete payment without tip
    setTimeout(() => onComplete(undefined, { transactionId: uuid() }), 2000);
  }

  return null;
};

export default AdyenManual;
